import { useEffect, useState } from "react";
import { Footer } from "@/components/Footer";
import { getPublicSettings } from "@/lib/api";

export const PageShell = ({ title, subtitle, testid, children, after }) => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    getPublicSettings().then(setSettings).catch(() => {});
    document.title = `${title} | Findivine | One Kind Earth Foundation`;
    window.scrollTo(0, 0);
    return () => {
      document.title = "Findivine | One Kind Earth Foundation";
    };
  }, [title]);

  return (
    <main data-testid={testid} className="min-h-screen bg-background text-foreground">
      <header className="fixed top-0 inset-x-0 z-50 bg-background/85 backdrop-blur-md border-b border-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
          <a href="/" data-testid="page-logo-link" className="flex flex-col leading-none">
            <span className="font-serif text-2xl sm:text-3xl font-semibold tracking-tight">Findivine</span>
            <span className="text-[9px] sm:text-[10px] tracking-[0.25em] uppercase text-primary font-bold">
              Divinity in Humanity
            </span>
          </a>
          <div className="flex items-center gap-4 sm:gap-7">
            <a href="/" data-testid="page-home-link"
               className="text-sm font-medium text-foreground/80 hover:text-primary transition-colors">
              Home
            </a>
            <a href="/#donate" data-testid="page-donate-btn"
               className="rounded-full bg-primary text-primary-foreground px-5 sm:px-6 py-2.5 text-sm font-semibold hover:scale-105 transition-transform">
              Donate Now
            </a>
          </div>
        </div>
      </header>

      <article className="max-w-3xl mx-auto px-6 pt-36 pb-24">
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight leading-[1.08] mb-4">{title}</h1>
        {subtitle && <p className="text-base md:text-lg text-muted-foreground mb-10">{subtitle}</p>}
        <div className="space-y-10">{children}</div>
      </article>

      {after}
      <Footer settings={settings} />
    </main>
  );
};

export const PolicySection = ({ title, children }) => (
  <section>
    {title && <h2 className="font-serif text-2xl sm:text-3xl text-foreground mb-3">{title}</h2>}
    <div className="space-y-3 text-base text-foreground/80 leading-relaxed">{children}</div>
  </section>
);
